import React from 'react';
import { VscProject } from "react-icons/vsc";
import { FcAbout } from "react-icons/fc";
import { GiSkills } from "react-icons/gi";
import { TiContacts } from "react-icons/ti";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { AiOutlineBlock } from 'react-icons/ai';


const Sidebar = ({ home, scrollToSection, about, contact, skill, project, blog }) => {

    return (
        <aside className=' mt-40 -ml-7 grid gap-y-8'>
            <div onClick={() => scrollToSection(home)}><HiOutlineHomeModern className=' w-6 h-6 hover:rotate-180 hover:transition'></HiOutlineHomeModern></div>
            <div onClick={() => scrollToSection(about)}><FcAbout className=' w-6 h-6  hover:rotate-180 hover:transition'></FcAbout></div>
            <div onClick={() => scrollToSection(project)}> <VscProject className='  w-6 h-6  hover:rotate-180 hover:transition'></VscProject></div>
            <div onClick={() => scrollToSection(skill)}><GiSkills className=' w-6 h-6  hover:rotate-180 hover:transition'></GiSkills></div>
            <div onClick={() => scrollToSection(blog)}><AiOutlineBlock className=' w-6 h-6  hover:rotate-180 hover:transition'></AiOutlineBlock></div>
            <div onClick={() => scrollToSection(contact)}> <TiContacts className='  w-6 h-6  hover:rotate-180 hover:transition'></TiContacts></div>
        </aside>
    );
};

export default Sidebar;